import { useMemo, useState } from 'react';
import { useKeyPressEvent } from 'react-use';

const useKeyboardFocus = (size: number, defaultActiveIndex?: number) => {
  const [currentFocus, setCurrentFocus] = useState(defaultActiveIndex ?? 0);

  useKeyPressEvent('ArrowDown', () => setCurrentFocus(currentFocus === size - 1 ? 0 : currentFocus + 1));
  useKeyPressEvent('ArrowUp', () => setCurrentFocus(currentFocus === 0 ? size - 1 : currentFocus - 1));

  return useMemo(() => [currentFocus, setCurrentFocus] as const, [currentFocus]);
};

export default useKeyboardFocus;
